const AUTH_TOKEN_KEY = 'auth_token';

function setAuthToken(token) {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  }
}

function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

function clearAuthToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

function extractTokenFromResponse(payload) {
  if (!payload) return null;
  if (typeof payload.token === 'string') return payload.token;
  if (payload.data && typeof payload.data.token === 'string') return payload.data.token;
  return null;
}

/** Persist JWT from a signin/signup/SSO response body when present. */
function persistAuthTokenFromResponse(payload) {
  const token = extractTokenFromResponse(payload);
  if (token) setAuthToken(token);
  return token;
}

export {
  AUTH_TOKEN_KEY,
  setAuthToken,
  getAuthToken,
  clearAuthToken,
  extractTokenFromResponse,
  persistAuthTokenFromResponse,
};
